import { Component,ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';


@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrl: './admin-panel.component.css',
})
export class AdminPanelComponent {
  constructor(private router: Router,){
  }

  @ViewChild('stepper') private stepper: MatStepper;
  selectedSection="cooler"
 
  SetSelectedSection(label:string){
    this.selectedSection=label
  }

  moveBack(){
    this.router.navigateByUrl("/planogram/planograms")
  }
}
